/**
 * React Query client + provider for the Workshop Dashboards feature.
 *
 * BON-64 adopts @tanstack/react-query for the dashboards' per-bucket data
 * fetching — 16 routes × distinct staleness needs would degrade with the
 * widget-telemetry-style useState+Promise.all pattern. The existing
 * WidgetTelemetry dashboard stays on its current pattern.
 *
 * Stale-time defaults: 30s for "this week" RD overview, longer for KPI
 * rollups; per-query overrides set inside each useQuery call.
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 30s default — dashboard reads tolerate brief staleness; refetch on
      // window focus is enough to feel fresh on tab-switch back.
      staleTime: 30 * 1000,
      // 5 min gc — keeps just-navigated-away buckets warm for bucket switches.
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});
